export const calcDate = (date1, date2) => {
  let date3 = date2 - date1;

  let days = Math.floor(date3 / (24 * 3600 * 1000))

  let leave1 = date3 % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
  let hours = Math.floor(leave1 / (3600 * 1000))

  let leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
  let minutes = Math.floor(leave2 / (60 * 1000))

  let leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
  let seconds = Math.round(leave3 / 1000)
  return {
    leave1,
    leave2,
    leave3,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  }
}

/**
 * 日期格式化
 */
export function dateFormat(date, format) {
  format = format || 'yyyy-MM-dd hh:mm:ss';
  if (date !== 'Invalid Date') {
    let o = {
      "M+": date.getMonth() + 1, //month
      "d+": date.getDate(), //day
      "h+": date.getHours(), //hour
      "m+": date.getMinutes(), //minute
      "s+": date.getSeconds(), //second
      "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
      "S": date.getMilliseconds() //millisecond
    }
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
      if (new RegExp("(" + k + ")").test(format))
        format = format.replace(RegExp.$1,
          RegExp.$1.length === 1 ? o[k] :
          ("00" + o[k]).substr(("" + o[k]).length));
    return format;
  }
  return '';
}
export function getMonthStartEnd(format = 'yyyy-MM-dd') {
  var now = new Date(); // 获取当前日期时间
  var startTime = dateFormat(new Date(now.getFullYear(), now.getMonth(), 1), format); // 获取本月第一天的日期时间
  var endTime = dateFormat(new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59), format); // 获取本月最后一天的日期时间（时间为23:59:59）

  return {
    startTime,
    endTime
  }
}

export function getNDaysBefore(n) {
  var now = new Date();
  var last = new Date(now.getTime() - n * 24 * 3600 * 1000);
  var year = last.getFullYear();
  var month = last.getMonth() + 1;
  if (String(month).length === 1) {
    month = '0' + String(month)
  }
  var date = last.getDate();
  if (String(date).length === 1) {
    date = '0' + String(date)
  }
  return year + '-' + month + '-' + date;
}
// 获取当天属于当年中第几周
export function getWeek(dt) {
  let d1 = new Date(dt);
  let d2 = new Date(dt);
  d2.setMonth(0);
  d2.setDate(1);
  let rq = d1 - d2;
  let days = Math.ceil(rq / (24 * 60 * 60 * 1000));
  let num = Math.ceil(days / 7);
  return num + 1;
}


export function getWeekRange(date) {
  let startTime = getWeekStartDate(date)
  let endTime = getWeekEndDate(date)
  return {
    startTime,
    endTime
  }
}

// 根据年份和周数 获取 周的开始和结束日期
export function getWeekStartDate(date) {
  let subDay = 0;
  let weekDay = date.getDay();
  if (weekDay == 0) {
    //周天
    subDay = 6;
  } else {
    subDay = weekDay - 1;
  }
  let beginDateTime = date.getTime() - (86400000 * subDay);
  let data = new Date(beginDateTime).getDate()
  let month = new Date(beginDateTime).getMonth() + 1
  let year = new Date(beginDateTime).getFullYear()
  return year + '-' + (month < 10 ? '0' + month : month) + '-' + (data < 10 ? '0' + data : data);
}
// 根据年份和周数 获取 周的开始和结束日期
export function getWeekEndDate(date) {
  let weekDay = date.getDay();
  if (weekDay == 0) {
    //周天
    let data = date.getDate()
    let month = date.getMonth() + 1
    let year = date.getFullYear()
    return year + '-' + (month < 10 ? '0' + month : month) + '-' + (data < 10 ? '0' + data : data);
  } else {
    let addDay = 7 - weekDay;
    let endDateTime = date.getTime() + (86400000 * addDay);
    let data = new Date(endDateTime).getDate()
    let month = new Date(endDateTime).getMonth() + 1
    let year = new Date(endDateTime).getFullYear()
    return year + '-' + (month < 10 ? '0' + month : month) + '-' + (data < 10 ? '0' + data : data);
  }
}

export function getLastMonth() {
  // 获取当前日期
  var currentDate = new Date();

  // 获取上个月的年份和月份
  var lastMonthYear = currentDate.getFullYear();
  var lastMonthMonth = currentDate.getMonth() - 1;

  // 如果当前月份是1月，则上个月的年份减1，月份为12
  if (lastMonthMonth === -1) {
    lastMonthYear = lastMonthYear - 1;
    lastMonthMonth = 11;
  }

  // 获取上个月的开始日期
  var lastMonthStartDate = dateFormat(new Date(lastMonthYear, lastMonthMonth, 1))
  // 获取上个月的结束日期
  var lastMonthEndDate = dateFormat(new Date(lastMonthYear, lastMonthMonth + 1, 0))
  return {
    lastMonthStartDate,
    lastMonthEndDate
  }
}
/**
 * 日期范围格式化
 */
 export function dateFormatRange(startTime, endTime) {
  let startTimeobj = new Date(startTime),
    startTimeYear = startTimeobj.getFullYear(),
    endTimeobj = new Date(endTime),
    endTimeYear = endTimeobj.getFullYear(),
    timeRange = "";
  if (startTimeYear !== new Date().getFullYear()) {
    timeRange += dateFormat(startTimeobj, "yyyy-MM-dd");
  } else {
    timeRange += dateFormat(startTimeobj, "MM-dd");
  }
  timeRange += " ~ ";
  if (endTimeYear !== new Date().getFullYear()) {
    timeRange += dateFormat(endTimeobj, "yyyy-MM-dd");
  } else {
    timeRange += dateFormat(endTimeobj, "MM-dd");
  }
  return timeRange;
}

/**
 * 当前时间戳
 */
export function dateNow() {
  return dateFormat(new Date(), "yyyyMMddhhmmss");
}
